export class SmsLengthUtils {
  private static readonly GSM_BASIC_CHARS =
    '@\u00a3$\u00a5\u00e8\u00e9\u00f9\u00ec\u00f2\u00c7\n\u00d8\u00f8\r\u00c5\u00e5\u0394_\u03a6\u0393\u039b\u03a9\u03a0\u03a8\u03a3\u0398\u039e\u00c6\u00e6\u00df\u00c9' +
    ' !"#\u00a4%&\'()*+,-./' +
    '0123456789:;<=>?' +
    '\u00a1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00c4\u00d6\u00d1\u00dc\u00a7\u00bf' +
    'abcdefghijklmnopqrstuvwxyz\u00e4\u00f6\u00f1\u00fc\u00e0';

  private static readonly GSM_EXTENDED_CHARS = '^{}\\[~]|\u20ac\f';

  private static readonly GSM_BASIC_CHAR_SET = new Set(Array.from(SmsLengthUtils.GSM_BASIC_CHARS));
  private static readonly GSM_EXTENDED_CHAR_SET = new Set(Array.from(SmsLengthUtils.GSM_EXTENDED_CHARS));

  static getLength(text: string, telqIdLength = 0): number {
    const message = text || '';
    return (this.isGsmText(message) ? this.getGsmLength(message) : message.length) + telqIdLength;
  }

  private static getGsmLength(text: string): number {
    return Array.from(text).reduce((length, char) => length + (this.GSM_EXTENDED_CHAR_SET.has(char) ? 2 : 1), 0);
  }

  private static isGsmText(text: string): boolean {
    return Array.from(text).every(char => this.isGsmChar(char));
  }

  private static isGsmChar(char: string): boolean {
    return this.GSM_BASIC_CHAR_SET.has(char) || this.GSM_EXTENDED_CHAR_SET.has(char);
  }
}
